import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <section className="relative pt-32 pb-20 bg-dark-900">
        <div className="absolute inset-0">
          <img
            src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b00a41c68dbe116920e19_t1.png"
            alt="About American Guard Services"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 font-display">
            About American Guard Services
          </h1>
          <p className="text-xl text-dark-100 max-w-3xl mx-auto">
            A trusted name in security services since 1997, providing professional protection across the United States.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">
                Our Story
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mt-4 mb-6 font-display">
                Building Trust Since 1997
              </h2>
              <p className="text-dark-600 text-lg mb-6 leading-relaxed">
                American Guard Services, Inc. was founded in 1997 with a simple mission: to provide professional, reliable security services that businesses and communities can trust. What started as a small, family-owned operation in Los Angeles has grown into a nationwide security provider serving 33 states.
              </p>
              <p className="text-dark-600 text-lg mb-6 leading-relaxed">
                As a woman-owned and woman-led company, we bring a unique perspective to the security industry. Our commitment to excellence, personal service, and community safety has earned us the trust of hundreds of clients across diverse industries.
              </p>
              <p className="text-dark-600 text-lg leading-relaxed">
                Today, we are proud to be SAFETY Act Certified by the U.S. Department of Homeland Security, a testament to our dedication to the highest standards of security service delivery.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b014df61ddc0361fdee96_American%20Guard%20Services_20251218-142%201.png"
                alt="Security Team"
                className="w-full h-64 object-cover rounded-lg"
              />
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/694b04a91cf8e0513931063e_American%20Guard%20Services_20251218-014.png"
                alt="Professional Guard"
                className="w-full h-64 object-cover rounded-lg mt-8"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-dark-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mb-6 font-display">
              Why Choose Us
            </h2>
            <p className="text-dark-600 text-lg max-w-3xl mx-auto">
              Our commitment to excellence sets us apart in the security industry.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-sm border border-dark-200">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-500/10 rounded-lg mb-6">
                <i className="ri-shield-check-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-dark-900 mb-3">Comprehensive Safety Coverage</h3>
              <p className="text-dark-600 text-sm leading-relaxed">
                Our services go beyond basic protection, offering full-spectrum safety coverage from all possible risks and unforeseen circumstances that may arise.
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm border border-dark-200">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-500/10 rounded-lg mb-6">
                <i className="ri-user-star-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-dark-900 mb-3">Highly Skilled Security Talent</h3>
              <p className="text-dark-600 text-sm leading-relaxed">
                We train our officers with a rigorous and modernized approach to security protocols for any and every situation to be handled with confidence.
              </p>
            </div>

            <div className="bg-white rounded-lg p-8 shadow-sm border border-dark-200">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-500/10 rounded-lg mb-6">
                <i className="ri-eye-off-line text-3xl text-primary-600"></i>
              </div>
              <h3 className="text-xl font-semibold text-dark-900 mb-3">Private Security Services</h3>
              <p className="text-dark-600 text-sm leading-relaxed">
                Our team delivers a reliable yet discreet presence in both routine and specialized environments, ensuring your safety and peace of mind.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="order-2 lg:order-1">
              <img
                src="https://cdn.prod.website-files.com/68b07a689aa678cd7b4261c6/690268243ab0bbae4cd4e46e_edited1.avif"
                alt="Team Culture"
                className="w-full h-96 object-cover rounded-lg"
              />
            </div>
            <div className="order-1 lg:order-2">
              <span className="text-primary-600 font-semibold text-sm uppercase tracking-wider">
                Company Culture
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mt-4 mb-6 font-display">
                Where Our People Matter Most
              </h2>
              <p className="text-dark-600 text-lg mb-6 leading-relaxed">
                American Guard Services, Inc. places people at the heart of everything we do. Our culture emphasizes trust, respect, and personal growth, ensuring employees never feel like they are just a number.
              </p>
              <p className="text-dark-600 text-lg leading-relaxed">
                We believe that when our team members are supported, valued, and encouraged to reach their full potential, they make a real difference for our clients and the communities we serve.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-primary-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-dark-900 mb-6 font-display">
            Join Our Team
          </h2>
          <p className="text-lg text-dark-800 mb-8">
            We're always looking for dedicated professionals to join our growing team. Explore career opportunities with American Guard Services.
          </p>
          <a
            href="https://www.jobsatags.com/welcome.aspx"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-dark-900 text-white rounded-lg text-base font-semibold hover:bg-dark-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            View Career Opportunities
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;